/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { createTransform, persistCombineReducers } from "redux-persist";
import { PersistConfig, Storage } from "redux-persist/es/types";
import storage from "redux-persist/es/storage";

import { DEFAULT_STORE } from "store/types";
import { createSetter } from "reducers/createReducer";
import { CamelCase, PrependSetTo } from "config/UtilityTypes";
import { keysOf, prependSetTo, snakeToCamelCase } from "config/Utilities";

const config: PersistConfig<object, Storage> = {
  key: String(process.env.REACT_APP_CONFIG),
  storage,
  transforms: [
    createTransform(
      (state: any) => state,
      (state: string) => (state ? new Date(state) : null),
      {
        whitelist: ["dayRangeStart", "dayRangeEnd"],
      }
    ),
    createTransform(
      (state: any) => state,
      (state: any) => Object.values(state),
      {
        whitelist: [
          "skillList",
          "curriculum",
          "regionList",
          "districtList",
          "storeListList",
          "userList",
          "skillProgressStoreList",
          "onboardingStoreList",
          "onboardingUserList",
          "sessionProgressStoreList",
          "sessionProgressUserList",
        ],
      }
    ),
  ],
};

type ReducersFor<Store extends Record<string, any>> = {
  [Key in keyof Store as CamelCase<Key>]: (
    state: Store[Key],
    action: { type: PrependSetTo<Key>; payload: Store[Key] }
  ) => Store[Key];
};

function createReducers(): ReducersFor<typeof DEFAULT_STORE> {
  const store = DEFAULT_STORE;
  const result: Partial<ReducersFor<typeof DEFAULT_STORE>> = {};
  for (const key of keysOf(store)) {
    result[snakeToCamelCase(key)] = createSetter(store[key], prependSetTo(key));
  }
  //@ts-ignore
  return result;
}

export const rootReducer = persistCombineReducers(config, createReducers());
